import { FC, ReactNode } from "react";
import { UrlObject } from "url";
import style from "./EditButton.module.scss";
import { Link } from "../Link/Link";
import { Text } from "../Text/Text";

interface Props {
  editUrl?: string | UrlObject;
  children: ReactNode;
}
export const EditButton: FC<Props> = ({ editUrl, children }) => {
  return editUrl !== undefined ? (
    <div className={style.root}>
      <Link href={editUrl} className="default outline">
        <Text variant="span">{children}</Text>
      </Link>
    </div>
  ) : null;
};
